import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { GlobalConstants } from 'src/app/services/global-constants';
@Component({
  selector: 'app-training-users-detail',
  templateUrl: './training-users-detail.component.html',
  styleUrls: ['./training-users-detail.component.scss']
})
export class TrainingUsersDetailComponent {

  @Input() sessionAtt: any;
  @Output() updatedAttendees: EventEmitter<any> = new EventEmitter<any>();
  @Input() courseId:string = '';
  attendees: any[] = [];
  attendeesId: any;
  fileProgress!: boolean;
  uploadProgress!: number;
  proof_url: any = [];
  staticURL = GlobalConstants.staticFilesURL;
  constructor(
    private dataService: DataService,
    private imageUploadService: ImageuploadService
  ) {


  }

  ngOnInit() {

    this.attendeesId = this.sessionAtt?.courseAttendees;
    if (this.sessionAtt?.attendanceProof?.proof_url) {
      this.proof_url = this.sessionAtt?.attendanceProof?.proof_url
    };

    this.getData();
  }


  //check its image or Vids
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  //Getting Initial Data in bulk
  getData = async () => {
    try {
      let query = {
        _id: { $in: this.sessionAtt?.courseAttendees }
      }
      let res = await this.dataService.postData('user/get', query);
      this.attendees = res?.data;

      this.attendees = this.attendees.map((item: any) => ({
        ...item,
        attend: this.sessionAtt?.attendees?.length ? this.sessionAtt?.attendees.some((f: any) => f == item?._id) : false
      }));

    } catch (error) {
      console.log(error);
    }
    this.attendees;

  };

  change(id: string, attend: boolean) {
    let checkItem;
    if (this.sessionAtt?.attendees?.length) {
      checkItem = this.sessionAtt?.attendees.findIndex((_id: any) => _id === id);
    }
    else {
      this.sessionAtt?.attendees?.length ? '' : this.sessionAtt.attendees = [];
      checkItem = -1;
    }


    if (attend && checkItem === -1) {
      this.sessionAtt?.attendees.push(id);
    }

    else if (!attend && checkItem !== -1) {

      this.sessionAtt?.attendees.splice(checkItem, 1);
    }
  }

  async saveAttendees() {
    let sessionUpdated = {
      _id: this.sessionAtt._id,
      attendees: this.sessionAtt?.attendees,
      attendanceProof: { proof_url: this.proof_url }
    }
    try {
      let res = await this.dataService.postData('session/', sessionUpdated, 'PUT', false);
      if (res.error) {


        return;
      }
      else {
        this.updatedAttendees.emit(this.sessionAtt?.attendees);

      }
    } catch (e) {
      console.log(e);
    }
  }

  async addFiles(event: any) {

    const file: File = event.target.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };
    console.log(obj);
    this.handleFileUpload(obj, 'file');
  }

  handleFileUpload(file: any, eventType: string): string | null {
    this.fileProgress = true;
    this.imageUploadService.uploadImageWithProgress(file.file.file, file.file.type).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.uploadProgress = Math.round(event.loaded / event.total! * 100);
            console.log(`Uploaded! ${this.uploadProgress}%`);
            break;
          case HttpEventType.Response:
            if (event.ok) {
              setTimeout(() => {
                this.uploadProgress = 0;
              }, 1500);
              switch (eventType) {
                case 'file':
                  this.proof_url.push({ url: event.body.data });


                  break;
                //next case working..
              }
            } else {
              console.log("Error here")
            }
        }
      },
      error: (error) => {
        this.fileProgress = false;
        this.uploadProgress = 0;
        console.log("Error here");
      },
      complete: () => {
        this.fileProgress = false;
        this.uploadProgress = 0;
        console.log("Success here");
      }
    })
    return ""
  }

}
